import { token } from '@atlaskit/tokens';
import { css } from '@emotion/core';

import {
  defaultMargin,
  borderTop,
  flexEnd,
  SPACE_MINIMUM,
  SPACE_COMPACT,
  SPACE_COZY,
  SPACE_RELAXED,
  flexCenter,
} from '@/styles';

const buttonSpacing = css`
  & > button {
    margin: ${SPACE_COZY}px 0;
    margin-left: ${SPACE_COMPACT}px;
  }
`;

export const formLayout = [
  defaultMargin,
  borderTop,
  css`
    display: grid;
    grid-gap: ${SPACE_COZY}px;
  `,
];

export const formDrawerOffset = css`
  margin-top: ${SPACE_MINIMUM}px;
  margin-right: ${SPACE_RELAXED}px;
  margin-left: ${SPACE_MINIMUM}px;
`;

export const formFieldBlockStyles = css`
  background-color: ${token('color.background.input.hovered')};
  border: 2px solid ${token('color.border.input')};
  padding: ${SPACE_COZY}px;
  border-radius: 4px;
`;

export const formFieldBlockHighlightStyles = css`
  border: 2px solid ${token('color.border.focused')};
`;

export const expandButtonStyles = css`
  border: 2px solid ${token('color.border')};
  border-radius: 13px;
  line-height: 1;
  width: 13px;
  height: 13px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
  ${flexCenter}
  span {
    position: relative;
    top: -1px;
  }
`;

export const expandTextStyles = css`
  font-size: 13px;
  text-transform: Capitalize;
`;

export const descriptionStyles = css`
  font-size: 12px;
  padding: 0 ${SPACE_MINIMUM}px;
  color: ${token('color.text.subtlest')};
  a {
    color: ${token('color.text.subtlest')};
    text-decoration: underline;
  }
`;

export const formFieldBlockTitleStyles = css`
  background: ${token('color.background.neutral')};
  padding: ${SPACE_MINIMUM}px ${SPACE_COMPACT}px;
  border-radius: 3px;
  label {
    margin-bottom: 0;
  }
`;

export const actionsLayout = [defaultMargin, flexEnd, borderTop, buttonSpacing];
